import React, { useContext, useEffect, useState } from "react";
import avatar from "../../Images/avatar.jpg";
import HomeService from "../../Services/HomeService";
import { useNavigate } from "react-router-dom";
import HttpClientXml from "../../utils/HttpClientXml";
import headlogo from "../../Images/Isolation_Mode.png";
import isolation from "../../Images/Isolation_Mode (1).png";
import isolation2 from "../../Images/Isolation_Mode (2).png";
import isolation3 from "../../Images/Isolation_Mode (3).png";
import Header2 from "../../Layout/Header2";
import pencil from "../../Images/fi_2682835.png";
import userimg from "../../Images/Ellipse 1582.png";
import star from "../../Images/Group (3).png";
import thunder from "../../Images/Vector (7).png";
import Suggestions from "./Suggestions";
import whitePencil from "../../Images/whitePencil.png";
import bg from "../../Images/Rectangle 34624331.png";
import camera from "../../Images/Group 1171279372.png";
import { FaYoutube } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { CiMail } from "react-icons/ci";
import { Context } from "../..";
const UserProfile = () => {
  const [profile, setProfile] = useState({});
  const [image, setImage] = useState("");
  // const [isEditClicked, setIsEditClicked] = useState(false);
  // const [formData, setFormData] = useState({
  //   address: "",
  //   companyName: "",
  //   email: "",
  //   fullName: "",
  //   image: "",
  //   mobileNo: "",
  // });
  const { loggedInUser, setLoggedInUser } = useContext(Context); // using context API

  const navigate = useNavigate();
  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("image", file);
      try {
        const response = await HttpClientXml.fileUplode(
          "image-upload",
          "POST",
          formData,
        );
        if (response?.status) {
          setImage(response.image);
        } else {
          console.error("Failed to upload image");
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    }
  };

  const getProfile = async () => {
    try {
      const response = await HomeService.getProfile();
      console.log("YTR60", response.data);

      if (response?.status) {
        setProfile(response.data);
        setLoggedInUser(response.data);
      } else {
        console.error("Failed to fetch profile data");
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  useEffect(() => {
    getProfile();
  }, []);

  const handleExitBtn = (e) => {
    e.preventDefault();
    navigate("/");
  };

  const handleSave = async (e) => {
    e.preventDefault();
    const data = {
      fullName: profile.fullName,
      city: profile.city,
      address: profile.address,
      mobileNo: profile.mobileNo,
      companyName: profile.companyName,
      image: image,
      workExpYear: Number(profile.workExpYear),
    };

    try {
      const res = await HomeService.updateProfile(data);
      if (res?.status) {
        getProfile();
      } else {
        console.error("Profile cannot be updated");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  const triggerFileInput = () => {
    document.getElementById("file-input").click();
  };

  // const handleEditClick = () => {
  //   setIsEditClicked(true);
  //   setFormData({
  //     address: profile.address,
  //     companyName: profile.companyName,
  //     email: profile.email,
  //     fullName: profile.fullName,
  //     image: profile.image,
  //     mobileNo: profile.mobileNo,
  //   });
  //   console.log("form data", formData);
  // };

  // if (!isEditClicked) {

  const openWhatsAppWithMessage = (message) => {
    const encodedMessage = encodeURIComponent(message);

    // This works for both WhatsApp Web & Desktop (if installed)
    const url = `https://wa.me/?text=${encodedMessage}`;

    window.open(url, "_blank");
  };

  const handleShareClick = () => {
    // const subject = `${property.propertytype?.propertyType} in ${property.locality?.name}`;
    const body =
      `Hi,\n` +
      `This is ${profile?.fullName || ""}\n` +
      `Address - ${profile?.address || ""}\n` +
      `Phone no - ${profile?.mobileNo || ""}\n` +
      `${profile?.workExpYear || ""} years of expertise in real estate\n` +
      `Website link: https://www.thewinners2.in/\n` +
      `Download link (Android App): https://play.google.com/store/apps/details?id=com.winners.properties`;

    // Gmail direct compose URL
    const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&body=${encodeURIComponent(body)}&to=`;

    // Outlook.com direct compose URL (optional, যদি Outlook ব্যবহার করতে চান)
    // const outlookComposeUrl = `https://outlook.live.com/mail/0/deeplink/compose?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.open(gmailComposeUrl, "_blank");
  };

  return (
    <>
      {/* <Header2/> */}
      <div
        className="pricing_plans_container user_profile_container56856"
        style={{
          position: "relative",
        }}
      >
        <img
          alt="background"
          src={bg}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
          }}
        />

        {/* <button className="edit_profile_btn">
          {" "}
          <img src={pencil} />
          Change Cover
        </button> */}
      </div>
      <div className="user_container56556">
        <div className="user_card_wrapper">
          <div className="user_left_sec_wrp">
            <div className="left_user_card_div">
              <div className="color_shape"></div>
              <div className="profile_information_div">
                <div
                  style={{
                    position: "relative",
                  }}
                >
                  <img
                    className="user_img_profile"
                    src={profile.image || avatar}
                    alt="avatar"
                  />
                  <span className="prof-active-dot"></span>
                  {/* <img
                  style={{
                    position: "absolute",
                    width: "40px",
                    bottom: "5px",
                    right: "10px",
                  }}
                  src={camera}
                /> */}
                </div>
                <h2>{profile.fullName}</h2>
                {/* <p>Private Employee</p> */}
                <div className="client_hand_propert_hand_div_wrapper">
                  <div
                    className="personal_details_1"
                    style={{
                      padding: "15px 20px",
                    }}
                  >
                    <h5>Client In Hand</h5>
                    <h6>
                      <span>{`${profile.clientsInHandCount} `}</span>clients in
                      hand
                    </h6>
                    {/* <h6>1 Cr bungalow for purchase in Kanpur.</h6> */}
                  </div>

                  <div
                    className="personal_details_1"
                    style={{
                      marginTop: "15px",
                      // borderTop: "1px solid rgba(0, 0, 0, 0.1)",
                      // borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
                      padding: "15px 20px",
                    }}
                  >
                    <h5>Property In Hand</h5>
                    <h6>
                      <span>{`${profile.propertiesInHandCount} `}</span>
                      properties in hand
                    </h6>
                    {/* <h6>1500 Sq. builder floor in Delhi.</h6> */}
                  </div>
                </div>
                {/* <button
                className="discover_btn_5"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  columnGap: "10px",
                }}
              >
                <img
                  style={{
                    width: "10px",
                  }}
                  src={thunder}
                />
                Message
              </button> */}
              </div>
            </div>
            <div className="socialPresenceCard">
              {/* Header */}
              <div className="socialPresenceHeader">
                <i className="fa-solid fa-globe socialPresenceIcon"></i>
                <h3>Social Presence</h3>
              </div>

              {/* User Icons */}
              <div className="socialPresenceUsers" style={{ display: "flex" }}>
                <div className="link-icon-wrp">
                  <div style={{ fontSize: "25px" }}>
                    <a
                      style={{ textDecoration: "none" }}
                      href={profile?.ytLink}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaYoutube style={{ color: "red" }} />
                    </a>
                  </div>
                  {/* <p>{profile?.ytLink}</p> */}
                </div>

                <div className="link-icon-wrp">
                  <div style={{ fontSize: "25px" }}>
                    <a
                      style={{ textDecoration: "none" }}
                      href={profile?.instaLink}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaInstagramSquare style={{ color: "#c1558b" }} />
                    </a>
                  </div>
                  {/* <p>{profile?.instaLink}</p> */}
                </div>

                <div className="link-icon-wrp">
                  <div style={{ fontSize: "25px" }}>
                    <a
                      style={{ textDecoration: "none" }}
                      href={profile?.fbLink}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaFacebook style={{ color: "blue" }} />
                    </a>
                  </div>
                  {/* <p>{profile?.fbLink}</p> */}
                </div>

                {/* <div className="socialUserCircle">
                 
                  <div>
                    <FaYoutube />
                  </div>
                  <label style={{ fontSize: "14px", marginLeft: "350%" }}>
                    {profile?.ytLink}
                  </label>
                </div> */}

                {/* <div className="socialUserCircle">
                  <div>
                    <FaInstagramSquare />
                  </div>
                  <label style={{ fontSize: "14px", marginLeft: "350%" }}>
                    {profile?.fbLink}
                  </label>
                </div> */}

                {/* <div className="socialUserCircle">
                  <div>
                    <FaFacebook />
                  </div>
                  <label style={{ fontSize: "14px", marginLeft: "350%" }}>
                    {profile?.fbLink}
                  </label>
                </div> */}
              </div>
            </div>
          </div>

          {/* hide for new ui */}
          {0 === 1 && (
            <div className="right_user_card_div">
              <h2>Personal Details </h2>
              <div className="personal_details_wrapper">
                <div className="personal_details_1">
                  <h5>Email</h5>
                  <p>{profile.email}</p>
                </div>

                <div className="personal_details_1">
                  <h5>Phone Number</h5>
                  <p>{profile.mobileNo}</p>
                </div>

                <div className="personal_details_1">
                  <h5>Address</h5>
                  <p>{profile.address}</p>
                </div>

                <div className="personal_details_1">
                  <h5>Company Name</h5>
                  <p>{profile.companyName}</p>
                </div>

                <div className="personal_details_1">
                  <h5>Working Localities</h5>
                  <p>Kanpur, Delhi, Faridabad</p>
                </div>
              </div>
              <div
                style={{
                  padding: "0px 20px",
                }}
              >
                <button
                  onClick={() => {
                    navigate("/edit-profile", {
                      state: {
                        currentPassword: profile.visiblePassword,
                      },
                    });
                  }}
                  className="discover_btn_5"
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    columnGap: "10px",
                  }}
                >
                  <img
                    style={{
                      width: "10px",
                    }}
                    src={whitePencil}
                    alt="edit"
                  />
                  Edit Profile
                </button>
              </div>
            </div>
          )}

          <div className="profileRightcontainer">
            <div className="profileCardContainer">
              <div className="profileCardHeader">
                <div>
                  <h2>Personal Details</h2>
                  <p>Manage your profile and account settings</p>
                </div>
                <div>
                  <label style={{ marginLeft: "40px", fontWeight: "600" }}>
                    Share
                  </label>
                  <div
                    style={{
                      display: "flex",
                      gap: "15px",
                      backgroundColor: "#ebf5f5",
                      // width: "60%",
                      padding: "10px 30px",
                      borderRadius: "15px",
                      // boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                      boxShadow: "0 6px 10px rgba(0, 0, 0, 0.1)",
                      // boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                    }}
                  >
                    <FaWhatsapp
                      onClick={() => {
                        openWhatsAppWithMessage(`
Welcome to the Winners Real Estate Data Portal.

Hi,
This is ${profile?.fullName || ""}
Company: ${profile?.companyName || ""}
Address - ${profile?.address || ""}
Phone no - ${profile?.mobileNo || ""}
${profile?.workExpYear || ""}+ years in real estate
Major Localities - ${profile?.majorLocality || ""}
Business Field - ${profile?.businessField || ""}

Please feel free to drop a message.

Website : https://www.thewinners2.in/
Download App : https://play.google.com/store/apps/details?id=com.winners.properties
`);
                      }}
                      style={{
                        fontSize: "30px",
                        color: "green",
                        cursor: "pointer",
                      }}
                    />
                    <CiMail
                      style={{
                        fontSize: "30px",
                        color: "red",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        handleShareClick();
                      }}
                    />
                  </div>
                </div>

                <button
                  className="editProfileBtn"
                  onClick={() => {
                    navigate("/edit-profile", {
                      state: {
                        currentPassword: profile.visiblePassword,
                      },
                    });
                  }}
                >
                  <i className="fas fa-pen"></i> Edit Profile
                </button>
              </div>

              <div className="profileInfoGrid">
                {/* Email */}
                <div className="profileInfoItem">
                  <div className="profileIconBox">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <div>
                    <span className="profileLabel">EMAIL ADDRESS</span>
                    <p className="profileValue">{profile.email}</p>
                  </div>
                </div>

                {/* Phone */}
                <div className="profileInfoItem">
                  <div className="profileIconBox">
                    <i className="fas fa-phone"></i>
                  </div>
                  <div>
                    <span className="profileLabel">PHONE NUMBER</span>
                    <p className="profileValue">{profile.mobileNo}</p>
                  </div>
                </div>

                {/* Address */}
                <div className="profileInfoItem">
                  <div className="profileIconBox">
                    <i className="fas fa-location-dot"></i>
                  </div>
                  <div style={{ width: "100%" }}>
                    <span className="profileLabel">CURRENT ADDRESS</span>
                    <p
                      className="profileValue"
                      style={{
                        width: "100%",
                        overflow: "scroll",
                        scrollbarWidth: "none", // Firefox এ scroll bar hide করবে
                        msOverflowStyle: "none", // IE এবং Edge এ scroll bar hide করবে
                        "&::-webkit-scrollbar": {
                          // Chrome, Safari, Opera এ scroll bar hide করবে
                          display: "none",
                        },
                      }}
                    >
                      {profile.address}
                    </p>
                  </div>
                </div>

                {/* Company */}
                <div className="profileInfoItem">
                  <div className="profileIconBox">
                    <i className="fas fa-building"></i>
                  </div>
                  <div>
                    <span className="profileLabel">COMPANY NAME</span>
                    <p className="profileValue">{profile.companyName}</p>
                  </div>
                </div>

                {/* Localities */}
                <div className="profileInfoItem fullWidth">
                  <div className="profileIconBox">
                    <i className="fas fa-briefcase"></i>
                  </div>

                  <div>
                    <span className="profileLabel">WORKING CITIES</span>

                    <div className="localityTags">
                      {profile?.workingCities?.length === 0 ? (
                        <span className="localityChip">No City Found</span>
                      ) : (
                        profile?.workingCities?.map((item, i) => (
                          <span key={i} className="localityChip">
                            {item?.name}
                          </span>
                        ))
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="profilePerformanceContainer">
              {/* Profile Performance Card */}
              <div className="profilePerformanceCard">
                <i className="fa-solid fa-gear profilePerformanceBgIcon"></i>

                <h3 className="profilePerformanceTitle">Profile Performance</h3>

                <p className="profilePerformanceText">
                  Your profile visibility has increased by <b>24%</b> this week.
                  Keep up the good work!
                </p>

                <button className="profilePerformanceBtn">
                  View Analytics
                </button>
              </div>

              {/* Verify Card */}
              <div className="profilePerformanceVerifyCard">
                <div>
                  <h3 className="profilePerformanceVerifyTitle">
                    Verify Account
                  </h3>

                  <p className="profilePerformanceVerifyText">
                    Add documents to get verified badge
                  </p>
                </div>

                <div className="profilePerformanceArrow">
                  <i className="fa-solid fa-chevron-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  // } else {
  //   return (
  //     <div
  //       style={{
  //         padding: "16px",
  //         maxWidth: "600px",
  //         margin: "0 auto",
  //         backgroundColor: "white",
  //         borderRadius: "16px",
  //         boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  //       }}
  //     >
  //       <h2
  //         style={{ fontSize: "24px", fontWeight: "600", marginBottom: "16px" }}
  //       >
  //         Edit Profile
  //       </h2>
  //       <form
  //         //onSubmit={handleSubmit}
  //         style={{ display: "flex", flexDirection: "column", gap: "16px" }}
  //       >
  //         <div
  //           style={{
  //             display: "flex",
  //             flexDirection: "column",
  //             alignItems: "center",
  //           }}
  //         >
  //           <img
  //             src={formData.image || avatar}
  //             alt="Profile"
  //             style={{
  //               width: "128px",
  //               height: "128px",
  //               objectFit: "cover",
  //               borderRadius: "50%",
  //               border: "1px solid #ddd",
  //             }}
  //           />
  //           <input
  //             type="file"
  //             accept="image/*"
  //             //onChange={handleImageChange}
  //             style={{ marginTop: "8px" }}
  //           />
  //         </div>
  //         <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
  //           <label style={{ color: "#1abdd6", fontWeight: "500" }}>Name</label>
  //           <input
  //             type="text"
  //             name="name"
  //             placeholder="Name"
  //             value={formData.fullName}
  //             //onChange={handleChange}
  //             style={{
  //               padding: "8px",
  //               border: "1px solid #ddd",
  //               borderRadius: "8px",
  //             }}
  //           />
  //         </div>
  //         <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
  //           <label style={{ color: "#1abdd6", fontWeight: "500" }}>Email</label>
  //           <input
  //             type="email"
  //             name="email"
  //             placeholder="Email"
  //             value={formData.email}
  //             //onChange={handleChange}
  //             style={{
  //               padding: "8px",
  //               border: "1px solid #ddd",
  //               borderRadius: "8px",
  //             }}
  //           />
  //         </div>
  //         <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
  //           <label style={{ color: "#1abdd6", fontWeight: "500" }}>
  //             Phone Number
  //           </label>
  //           <input
  //             type="tel"
  //             name="phone"
  //             placeholder="Phone Number"
  //             value={formData.mobileNo}
  //             //onChange={handleChange}
  //             style={{
  //               padding: "8px",
  //               border: "1px solid #ddd",
  //               borderRadius: "8px",
  //             }}
  //           />
  //         </div>
  //         <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
  //           <label style={{ color: "#1abdd6", fontWeight: "500" }}>
  //             Address
  //           </label>
  //           <textarea
  //             type="text"
  //             name="address"
  //             placeholder="Address"
  //             value={formData.address}
  //             //onChange={handleChange}
  //             style={{
  //               padding: "8px",
  //               border: "1px solid #ddd",
  //               borderRadius: "8px",
  //             }}
  //           />
  //         </div>
  //         <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
  //           <label style={{ color: "#1abdd6", fontWeight: "500" }}>
  //             Company Name
  //           </label>
  //           <input
  //             type="text"
  //             name="company"
  //             placeholder="Company Name"
  //             value={formData.companyName}
  //             // onChange={handleChange}
  //             style={{
  //               padding: "8px",
  //               border: "1px solid #ddd",
  //               borderRadius: "8px",
  //             }}
  //           />
  //         </div>
  //         <button
  //           type="submit"
  //           style={{
  //             backgroundColor: "#3b82f6",
  //             color: "white",
  //             padding: "8px",
  //             borderRadius: "8px",
  //             border: "none",
  //             cursor: "pointer",
  //             hover: { backgroundColor: "#2563eb" },
  //           }}
  //         >
  //           Update
  //         </button>
  //       </form>
  //     </div>
  //   );
  // }
};

export default UserProfile;
